module.exports = __webpack_public_path__ + "static/media/empresa-original-ad.7162bb2a.png";